import { render, staticRenderFns } from "./ExcelDataTable.vue?vue&type=template&id=ff5c0420&scoped=true&"
import script from "./ExcelDataTable.vue?vue&type=script&lang=ts&"
export * from "./ExcelDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ExcelDataTable.vue?vue&type=style&index=0&id=ff5c0420&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5c0420",
  null
  
)

export default component.exports